import React from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker, DayOfWeek } from 'office-ui-fabric-react';

import { datePickerStrings } from './metaDataDatePickers/datePickerStrings';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { formatDateForApi } from '../../../../../features/helpers/dateHelpers';

const onFormatDate = (date) => {
  return (
    ('0' + date.getDate()).slice(-2) +
    '/' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '/' +
    date.getFullYear()
  );
};

const datePickerStyles = {
  root: {
    padding: '20px 0',
  },
};

const MetaDataDatePickers = ({
  hearingModel,
  updateHearingModelAttribute,
  showErrors,
}) => {
  const { t: translator } = useTranslation();

  const onChangeStartDateCallback = (value) => {
    updateHearingModelAttribute('startDate', formatDateForApi(value));
    if (value > getDeadlineAsDate()) {
      updateHearingModelAttribute('deadline', null);
    }
  };

  const onChangeDeadlineCallback = (value) =>
    updateHearingModelAttribute('deadline', formatDateForApi(value));

  const getDeadlineAsDate = () => {
    const deadline = getAttr(hearingModel, 'deadline');
    return deadline && new Date(deadline);
  };

  const getStartDateAsDate = () => {
    const deadline = getAttr(hearingModel, 'startDate');
    return deadline && new Date(deadline);
  };

  const getMinDeadlineAsDate = () => {
    const startDate = getAttr(hearingModel, 'startDate');

    const date = startDate ? new Date(startDate) : new Date();

    date.setDate(date.getDate() + 1);
    return date;
  };

  return (
    <div className="create-hearing-date-pickers">
      <div id="agora-app-date-picker">
        <DatePicker
          label={translator('hearingProperties.startDate')}
          firstWeekOfYear={2}
          firstDayOfWeek={DayOfWeek.Monday}
          strings={datePickerStrings}
          placeholder={translator('pages.createHearing.chooseStartDate')}
          onSelectDate={onChangeStartDateCallback}
          minDate={new Date()}
          value={getStartDateAsDate()}
          isMonthPickerVisible={false}
          formatDate={onFormatDate}
          styles={datePickerStyles}
          textField={{
            errorMessage:
              showErrors && !getStartDateAsDate()
                ? translator('global.requiredField')
                : null,
          }}
        />
      </div>
      <div id="agora-app-date-picker">
        <DatePicker
          label={translator('hearingProperties.deadlineDate')}
          firstWeekOfYear={2}
          firstDayOfWeek={DayOfWeek.Monday}
          strings={datePickerStrings}
          onSelectDate={onChangeDeadlineCallback}
          minDate={getMinDeadlineAsDate()}
          value={getDeadlineAsDate()}
          isMonthPickerVisible={false}
          formatDate={onFormatDate}
          placeholder={translator('pages.createHearing.chooseDeadlineDate')}
          styles={datePickerStyles}
          disabled={!getAttr(hearingModel, 'startDate')}
          textField={{
            errorMessage:
              showErrors && !getDeadlineAsDate()
                ? translator('global.requiredField')
                : null,
          }}
        />
      </div>
    </div>
  );
};

export { MetaDataDatePickers };
